export default __webpack_public_path__ + "static/universal-fm-f52ce92967a49a4c3fb8dfad4c9af600.jpg";